/**
 * Creates a {@link SynchronizerV1} that will update an instance of \@ngx-translate/core TranslateService
 * @public
 * @example
 * Simple example:
 * ```ts
 * class MyNgModule {
 * 	public constructor(ngTranslate: TranslateService) {
 * 		translationManager.addSynchronizer(ngxTranslateCodeSynchronizer(ngTranslate));
 * 	}
 * }
 * ```
 * @param ngService - \@ngx-translate/core TranslateService instance
 * @returns Instance of {@link SynchronizerV1}
 */
export function ngxTranslateCodeSynchronizer(ngService, ngZone) {
    return {
        languageChange(language) {
            if (ngZone) {
                // If NgZone is provided, we run the actions inside the Zone to allow Angular to know about it
                ngZone.run(() => ngService.use(language));
                return;
            }
            ngService.use(language);
        },
        storeChange(language, store) {
            const keys = Object.fromEntries(store.entries());
            if (ngZone) {
                // If NgZone is provided, we run the actions inside the Zone to allow Angular to know about it
                ngZone.run(() => ngService.setTranslation(language, keys, true));
                return;
            }
            ngService.setTranslation(language, keys, true);
        },
    };
}
